import React from "react";
import PropTypes from "prop-types";
import { graphql, StaticQuery } from "gatsby";
import PreviewCompatibleImage from "./PreviewCompatibleImage";
import { kebabCase } from "lodash";

class TrailLogoByNameTemplate extends React.Component {
  render() {
    const { data, arg } = this.props;

    let trailName = arg.name;
    let className = arg.className;
    let image = arg.image;

    const { edges: posts } = data.allMarkdownRemark;

    let trailData = [];

    posts.forEach((post) => {
      trailData[post.node.frontmatter.title] = post.node;
    });

    //console.log(trailData);

    if (image && image !== "undefined") {
      return (
        <>
          <span key={`trail___${kebabCase(trailName)}`}>
            <PreviewCompatibleImage
              imageInfo={{
                image: image,
                alt: trailName,
                className: className,
              }}
            />
          </span>
        </>
      );
    } else if (trailData[trailName]) {
      let { trail } = trailData[trailName].frontmatter;

      return (
        <>
          <span key={`trail___${kebabCase(trailName)}`}>
            <PreviewCompatibleImage
              imageInfo={{
                image: trail.logo,
                alt: trailName,
                className: className,
              }}
            />
          </span>
        </>
      );
    } else {
      return null;
    }
  }
}

TrailLogoByName.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
};

export default function TrailLogoByName(arg) {
  return (
    <StaticQuery
      query={graphql`
        query TrailLogoByNameQuery {
          allMarkdownRemark(
            sort: { frontmatter: { name: ASC } }
            filter: {
              frontmatter: { templateKey: { eq: "mtb-shuttles-post" } }
            }
          ) {
            edges {
              node {
                html
                fields {
                  slug
                }
                frontmatter {
                  title
                  subtitle
                  image {
                    childImageSharp {
                      gatsbyImageData(
                        quality: 100
                        layout: FULL_WIDTH
                        placeholder: BLURRED
                      )
                    }
                  }
                  meta {
                    showTitle
                  }
                  trail {
                    logo {
                      childImageSharp {
                        gatsbyImageData(
                          quality: 100
                          layout: FULL_WIDTH
                          placeholder: BLURRED
                        )
                      }
                    }
                    miles
                    descent
                    elevationGain
                    high
                    low
                    aveGrade
                    maxGrade
                    stravaIframeURL
                  }
                  gallery {
                    images {
                      image {
                        childImageSharp {
                          resize(width: 1920, height: 1080, cropFocus: CENTER) {
                            src
                          }
                        }
                      }
                    }
                  }
                  highlights {
                    highlight {
                      image {
                        childImageSharp {
                          gatsbyImageData(
                            quality: 100
                            layout: FULL_WIDTH
                            placeholder: BLURRED
                          )
                        }
                      }
                      title
                      summary
                    }
                  }
                  pickups {
                    pickup {
                      title
                    }
                  }
                  summary
                  price
                }
              }
            }
          }
        }
      `}
      render={(data, count) => (
        <TrailLogoByNameTemplate data={data} count={count} arg={arg} />
      )}
    />
  );
}
